module.exports = __webpack_public_path__ + "media/images/polly-logo-b41251df96a8b04ae506c47324d9be60.png";